// extracted by mini-css-extract-plugin
export default {"cardDark":"DetailCard_cardDark__Y7Q2J","card":"DetailCard_card__tGua4","button":"DetailCard_button__WjiiA"};